import { Area } from './area';

export interface FloorplanForm {
  name: string;
  description: string;
  imageUrl: string;
  menuPdf: Blob;
}

export interface Floorplan {
  eventId?: string;
  floorplanId?: string;
  name: string;
  description: string;
  imageUrl: string;
  areas: Area[];
  menuUrl?: string;
  menuFilename?: string;
  menuPdf?: string;
}

export interface FloorplanResponse {
  id: string;
  eventId?: string;
  name: string;
  description: string;
  imageUrl: string;
  areas: Area[];
  menuUrl: string;
  menuFilename?: string;
}

export interface FloorplanEditorSettings {
  skipDesignModeOnboarding: boolean;
  skipOffersModeOnboarding: boolean;
  previouslyUsedColors: string[];
}

export const EMPTY_FLOORPLAN: Floorplan = {
  name: '',
  description: '',
  floorplanId: '',
  imageUrl: '',
  eventId: '',
  areas: [],
  menuFilename: '',
  menuUrl: '',
};

export interface Point {
  x: number;
  y: number;
}

export interface SeatingItemLabel {
  prefix: string | null;
  number: string;
}

export const SEATING_ITEM_SHAPE_TYPES = ['circle', 'square'] as const;
export type SeatingItemShapeType = (typeof SEATING_ITEM_SHAPE_TYPES)[number];

export interface SeatingItemShape {
  type: SeatingItemShapeType;
  width: number | null;
  height: number | null;
  radius: number | null;
}

export interface SeatingItemGeometry {
  anchor: Point;
  shape: SeatingItemShape;
  rotation: number | null;
}

export interface SeatingItem {
  id: string;
  label: SeatingItemLabel;
  geometry: SeatingItemGeometry;
  color: string | null;
  locked: boolean;
  offerId: string | null;
}

export interface SeatingGroup {
  id: string;
  selectionMode: 'itemSpecific' | 'groupOnly';
  anchor: Point | null;
  seatingItems: SeatingItem[];
}

export interface FloorplanAreaPolygonShape {
  type: 'polygon';
  points: Point[];
}

export interface FloorplanAreaGeometry {
  shape: FloorplanAreaPolygonShape;
  anchor: Point | null;
}

export interface FloorplanArea {
  id: string;
  name: string;
  orderPosition: number | null;
  geometry: FloorplanAreaGeometry | null;
  seatingGroups: SeatingGroup[];
  seatingItems: SeatingItem[];
}

export interface FloorplanSchema {
  revision: number;
  areas: FloorplanArea[];
  seatingGroups: SeatingGroup[];
  seatingItems: SeatingItem[];
}

export interface FloorplanViewportVertex {
  x: number;
  y: number;
}

export interface FloorplanViewportDrawingState {
  vertices: FloorplanViewportVertex[];
  isPolygonClosed: boolean;
  areaName: string;
}

export interface FloorplanViewportSnapshot {
  version: 1;
  drawing: FloorplanViewportDrawingState | null;
  usedColors?: string[];
  offersMode?: boolean;
}

export interface FloorplanViewportSnapshotResponse {
  content: FloorplanViewportSnapshot;
}

export interface FloorplanSchemaEventSelection {
  all: boolean;
  ids: string[];
}

export interface SaveFloorplanSchemaBody extends FloorplanSchema {
  publish?: boolean | null;
  eventSelection?: FloorplanSchemaEventSelection | null;
}
